{
  "tabs": {
    "chat": "Petear",
    "reminders": "Herinneringen",
    "calendar": "Kalinder",
    "settings": "Ynstellings"
  },
  "common": {
    "cancel": "Ofbrekke",
    "save": "Bewarje",
    "confirm": "Befêstigje",
    "delete": "Wiskje",
    "back": "Werom",
    "close": "Slute",
    "edit": "Bewurkje",
    "search": "Sykje",
    "all": "Alles",
    "loading": "Laden...",
    "error": "Der is wat misgien",
    "notFound": "Net fûn",
    "tryAgain": "Besykje it op 'e nij",
    "retry": "Op 'e nij",
    "undo": "Oermeitsje",
    "pullToRefresh": "Sleep om te fernijen",
    "justNow": "krekt no"
  },
  "auth": {
    "welcome": "Wolkom by FishMemory",
    "tagline": "Dyn WhatsApp herinneringsassistent, no yn dyn bûse.",
    "subtitle": "Dyn WhatsApp herinneringsassistent, no yn dyn bûse.",
    "phoneLabel": "Dyn WhatsApp nûmer",
    "phoneHint": "Wy stjoere in ferifikaasjekoade fia WhatsApp",
    "invalidPhone": "Fier in jildich telefoannûmer yn",
    "continue": "Trochgean",
    "enterPhone": "Fier dyn WhatsApp nûmer yn",
    "phonePlaceholder": "Telefoannûmer",
    "sendCode": "Stjoer Koade",
    "verifyTitle": "Ferifiearje dyn nûmer",
    "otpSentTo": "In 6-sifers koade is stjoerd nei {{phone}} fia WhatsApp",
    "enterFullCode": "Fier alle 6 sifers yn",
    "invalidOtp": "Unjildige koade. Besykje it op 'e nij.",
    "otpFailed": "Koade stjoeren mislearre. Besykje it op 'e nij.",
    "otpResent": "Koade op 'e nij stjoerd",
    "resendIn": "Op 'e nij stjoere yn {{seconds}}s",
    "resendCode": "Koade op 'e nij stjoere",
    "enterOtp": "Fier de koade yn dy't nei dyn WhatsApp stjoerd is",
    "verify": "Ferifiearje",
    "resend": "Koade op 'e nij stjoere",
    "wrongNumber": "Ferkeard nûmer?",
    "backToPhone": "Werom nei tillefoan",
    "editPhone": "Bewurkje telefoannûmer",
    "error": "Flater",
    "setupTitle": "Litte wy it ynstelle",
    "setupSubtitle": "Jo kinne dit letter altyd feroarje yn Ynstellings",
    "namePlaceholder": "Dyn namme",
    "letsGo": "Klear mei ynstelle",
    "skipForNow": "Oerslaan foar no"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Typ in berjocht...",
    "inputPlaceholder": "Typ in berjocht...",
    "typing": "FishMemory is oan it typen...",
    "online": "Online",
    "connecting": "Ferbine...",
    "reconnecting": "Opnij ferbinen...",
    "offline": "Offline",
    "empty": "Begjin in petear",
    "emptyHint": "Meitsje herinneringen, sjoch dyn skema, of freegje om help.",
    "emptyAction": "Stjoer in foarbyldherinnering",
    "actions": "Petearaksjes",
    "keep": "Berjochten bewarje",
    "clearTitle": "Petear wiskje",
    "clearConfirm": "Wiskje alle berjochten fan dit apparaat? Dit kin net weromdraaid wurde.",
    "clear": "Petear wiskje",
    "optionSelected": "Keazen: {{label}}",
    "sendingSelection": "Stjoeren...",
    "connectionLost": "Opnij ferbinen..."
  },
  "reminders": {
    "title": "Myn Herinneringen",
    "active": "Aktyf",
    "today": "Hjoed",
    "thisWeek": "Dizze wike",
    "history": "Skiednis",
    "items": "items",
    "emptyTitle": "Noch gjin herinneringen",
    "emptySubtitle": "Meitsje der ien fan petear en hy ferskynt hjir.",
    "emptyAction": "Iepenje petear",
    "filterActive": "Aktyf",
    "filterToday": "Hjoed",
    "filterWeek": "Dizze wike",
    "filterHistory": "Skiednis",
    "emptyState": "Noch gjin herinneringen. Begjin te petearjen!",
    "swipeDone": "Klear",
    "swipeSnooze": "Snooze",
    "swipeDelete": "Wiskje",
    "search": "Sykje herinneringen...",
    "upcoming": "Oankommend",
    "completed": "Klear",
    "overdue": "Oer tiid",
    "tomorrow": "Moarn",
    "synced": "Sinkeare {{value}}",
    "swipeHint": "Swipe in herinnering foar mear aksjes",
    "noResults": "Gjin herinneringen komme oerien mei jo syktocht",
    "noResultsHint": "Besykje in oar trefwurd of wiskje de syktocht",
    "deleteAllFailed": "It wiskjen fan alle herinneringen is mislearre"
  },
  "calendar": {
    "title": "Kalinder",
    "today": "Hjoed",
    "tomorrow": "Moarn",
    "completed": "klear",
    "noEvents": "Gjin skema",
    "noEventsSubtitle": "Kies in datum om herinneringen en kalindereveneminten te sjen.",
    "googleEvent": "Google Kalinder",
    "legendActive": "Aktyf",
    "legendRecurring": "Werhellend",
    "legendDone": "Klear",
    "legendGoogle": "Google",
    "previousMonth": "Foardere moanne",
    "nextMonth": "Folgjende moanne",
    "previousYear": "Foardere jier",
    "nextYear": "Folgjende jier",
    "goToToday": "Gean nei hjoed",
    "all": "Alles",
    "active": "Aktyf",
    "done": "Klear",
    "paused": "Pauze"
  },
  "settings": {
    "title": "Ynstellings",
    "profile": "Profyl",
    "name": "Werjaan Namme",
    "enterName": "Fier dyn namme yn",
    "language": "Taal",
    "uiLanguage": "App taal",
    "uiLanguageHelp": "Feroaret de app UI, kalinderlabels, en layout rjochting allinnich op dit apparaat.",
    "serverLanguage": "Petear taal",
    "serverLanguageHelp": "Feroaret de taal dy't brûkt wurdt troch server antwurden en herinneringsberjochten foar dyn akkount.",
    "timezone": "Tiidsône",
    "currentTimezone": "Hjoeddeistige tiidsône",
    "timezoneHelp": "Alle herinneringstiid wurdt toand mei dizze tiidsône.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Bewarje tiidsône",
    "timezoneSaved": "Tiidsône bywurke",
    "detect": "Detectearje",
    "detectFailed": "Kin tiidsône net detectearje",
    "autoDetect": "Automatysk detectearje fan GPS",
    "notifications": "Meldingen",
    "notificationsHelp": "Folgjende herinneringen kontrolearje werhelle warskôgings nei't in herinnering levere is. Meldingsrjochten op apparaatnivo wurde noch beheard yn dyn telefoanynstellings.",
    "pushEnabled": "Push Meldingen",
    "autoDoneOnFire": "Automatysk as klear markearje by ôfgean",
    "autoDoneOnFireDesc": "As út, bliuwe herinneringen aktyf oantst se klear markearrest.",
    "googleCalendar": "Google Kalinder",
    "google": "Google Kalinder",
    "googleConnected": "Ferbûn",
    "googleDisconnected": "Net ferbûn",
    "googleConnectedHelp": "Nije herinneringen kinne automatysk mei dyn kalinder syngronisearre wurde.",
    "googleDisconnectedHelp": "Ferbine Google Kalinder om herinneringen en eveneminten opinoar ôf te stimmen.",
    "googleConnectFailed": "Ferbining mei Google Kalinder mislearre",
    "connected": "Ferbûn",
    "disconnected": "Net ferbûn",
    "connect": "Ferbine",
    "disconnect": "Ferbining wiskje",
    "autoSync": "Automatyske syngronisaasje fan nije herinneringen",
    "autosync": "Automatyske syngronisaasje fan nije herinneringen",
    "subscription": "Abonnemint",
    "trialUsed": "Proef: {{used}}/{{total}} brûkt",
    "trialStatus": "Proef beskikber",
    "activeStatus": "Aktyf abonnemint",
    "expiredStatus": "Abonnemint ferrûn",
    "unsubscribedStatus": "Net abonnemint",
    "about": "Oer",
    "version": "Ferzje",
    "logout": "Útlogge",
    "logoutTitle": "Útlogge",
    "logoutConfirm": "Binne jo wis dat jo útlogge wolle?",
    "noName": "Gjin namme ynsteld",
    "serverConnection": "Serverferbining",
    "serverUrl": "Server URL",
    "serverEdit": "Bewurkje",
    "saveReconnect": "Bewarje en opnij ferbine",
    "resetDefault": "Standert weromsette",
    "invalidServerUrlTitle": "Unjildige server URL",
    "invalidServerUrlMessage": "Fier in jildige http of https server URL yn, bygelyks https://example.com",
    "uiLanguageChangeFailed": "Feroaring fan app taal mislearre. Besykje it op 'e nij.",
    "serverLanguageChangeFailed": "Feroaring fan petear taal mislearre. Besykje it op 'e nij.",
    "timezoneChangeFailed": "Feroaring fan tiidsône mislearre. Besykje it op 'e nij.",
    "autoSyncChangeFailed": "Bywurking fan automatyske syngronisaasje mislearre. Besykje it op 'e nij.",
    "nameChangeFailed": "Bywurking fan werjaan namme mislearre. Besykje it op 'e nij.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Details fan herinnering",
    "editTime": "Tiid bewurkje",
    "rename": "Namme feroarje",
    "snooze": "Snooze",
    "snooze15": "Snooze 15 minuten",
    "pause": "Pauze",
    "pauseReminder": "Herinnering pauzearje",
    "resume": "Trochgean",
    "resumeReminder": "Herinnering trochgean",
    "skip": "Folgjende oerslaan",
    "skipOccurrence": "Dizze kear oerslaan",
    "syncGoogle": "Syngronisearje mei Google",
    "delete": "Wiskje",
    "deleteTitle": "Herinnering wiskje",
    "deleteConfirm": "Dizze herinnering wurdt permanint wiskd.",
    "deleteRecurringTitle": "Werhellende herinnering wiskje",
    "deleteRecurringMessage": "Wolle jo dizze kear oerslaan of de hiele searje wiskje?",
    "deleteThisOccurrence": "Dizze kear oerslaan",
    "deleteEntireSeries": "Hiele searje wiskje",
    "done": "Klear",
    "markDone": "As klear markearje",
    "undo": "Herstelle",
    "undoPrompt": "Nedich om it wer aktyf te meitsjen? Herstel it no.",
    "recurring": "Werhellend",
    "nextRun": "Folgjende kear",
    "oneTime": "Ien kear",
    "pending": "Wachtsjend",
    "sent": "Stjoerd",
    "paused": "Pauze",
    "active": "Aktyf",
    "snoozed": "Snoozed",
    "localTime": "Toand yn dyn lokale tiid",
    "recurrence": "Werhelling",
    "created": "Makke",
    "tags": "Tags",
    "fireCount": "Kearen ôfgean",
    "actions": "Aksjes",
    "none": "Gjin",
    "snoozeFailed": "Snooze fan herinnering mislearre",
    "pauseFailed": "Pauze fan herinnering mislearre",
    "resumeFailed": "Trochgean fan herinnering mislearre",
    "skipFailed": "Oerslaan fan herinnering mislearre",
    "doneFailed": "Markearjen fan herinnering as klear mislearre",
    "undoFailed": "Herstellen fan status fan herinnering mislearre",
    "deleteFailed": "Wiskjen fan herinnering mislearre",
    "rescheduleTitle": "Opnij plannen?",
    "rescheduleMsg": "Dizze herinnering is oer tiid. Wolle jo it opnij plannen?",
    "reschedule15": "Oer 15 minuten",
    "reschedule60": "Oer 1 oere",
    "keepOverdue": "Hâld sa"
  },
  "onboarding": {
    "slide1Title": "Wolkom by FishMemory",
    "slide1Sub": "Dyn persoanlike herinneringsassistent — oandreaun troch WhatsApp en makke foar dyn bûse.",
    "slide2Title": "Gewoan Natuerlik Petearje",
    "slide2Sub": "Typ herinneringen sa'tst tinkst: \"Herinner my moarn om 3 oere om mem te skiljen\" — wy regelje de rest.",
    "slide3Title": "Mis Nooit Wat",
    "slide3Sub": "Krij op tiid warskôgings, organisearje mei tags, en bliuw op 'e hichte fan alles wat wichtich is.",
    "getStarted": "Begjin",
    "next": "Folgjende",
    "firstReminderTitle": "Meitsje dyn earste herinnering!",
    "firstReminderHint": "Besykje wat te typen lykas:",
    "firstReminderExample": "Herinner my moarn om 9 oere om wetter te drinken",
    "gotIt": "Begrepen!",
    "notifRationaleTitle": "Bliuw op tiid",
    "notifRationaleBody": "FishMemory hat meldingen nedich om dy op tiid te herinnerjen. Jo krije allinnich warskôgings foar herinneringen dy't jo meitsje.",
    "notifRationaleAllow": "Meldingen ynskeakelje",
    "notifRationaleLater": "Miskien letter",
    "swipeHint": "Swipe rjochts foar flugge aksjes →",
    "calendarDragHint": "Sleep om út te wreidzjen ↕"
  }
}
